import { useEffect, useRef } from 'react'

import type { TFullCommunityApi } from '@/src/features/community/api/communityApi.types'
import { NOTIFICATION_CATEGORY } from '@/src/features/notification/models/notification.constants'
import { useNotificationSettingsMutation } from '@/src/features/notification/services/useNotificationSettingsMutation'

import { withFraternity } from '../../utils/withFraternity'

/**
 * On community with fraternity join, publication email + push prefs default to true.
 */
export const useFraternityJoinPublicationPrefs = (community?: Pick<TFullCommunityApi, 'id' | 'tags'>) => {
  const hasApplied = useRef(false)
  const { mutate: editNotificationSettings } = useNotificationSettingsMutation(NOTIFICATION_CATEGORY.PUBLICATIONS)

  const isWithFraternity = community ? withFraternity(community) : false
  const communityId = community?.id

  useEffect(() => {
    if (!isWithFraternity || !communityId || hasApplied.current) return
    hasApplied.current = true
    editNotificationSettings({ [communityId]: { email: true, push: true } })
  }, [communityId, editNotificationSettings, isWithFraternity])
}
